__turbopack_context__.v({
  "buttons": "Pagination-module__VZLhZW__buttons",
  "pagination": "Pagination-module__VZLhZW__pagination",
  "paginationSummaryLine": "Pagination-module__VZLhZW__paginationSummaryLine",
  "selector": "Pagination-module__VZLhZW__selector",
  "wrap": "Pagination-module__VZLhZW__wrap",
});
